<!-- OnlinePlayer.vue -->
<script setup>
import { ref, computed } from 'vue'
import { useAuthStore } from '../../stores/auth'
import { usePlayerStore } from '../../stores/player/playerStore'
import { useI18n } from 'vue-i18n'
import LanguageSwitcher from '../LanguageSwitcher.vue'  // Agregamos esta línea
import PlayerReports from './PlayerReports.vue';



const { t } = useI18n();
const authStore = useAuthStore();
const playerStore = usePlayerStore();
const showReports = ref(false);

const showUserModal = ref(false)
const toggleUserModal = () => {
  showUserModal.value = !showUserModal.value
}

const currency_prefix = computed(() => playerStore.currencyPrefix)
const formattedBalance = computed(() => {
  return Number(playerStore.balance).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
})

const isAuthenticated = computed(() => authStore.isAuthenticated);

const openReports = () => {
  showReports.value = true;
};

const closeReports = () => {
  showReports.value = false;
};
</script>


<template>
  <div v-if="isAuthenticated" class="online-player-wrapper">
    <!-- Balance Button in Header -->
    <button class="balance-button" @click="toggleUserModal">
     
      <span class="balance-amount">{{ t('account.balance') }}: <p>{{ currency_prefix }} {{ formattedBalance }}</p></span>
    </button>

    <!-- User Modal -->
    <div v-if="showUserModal" class="modal-overlay" @click.self="toggleUserModal">
      <div class="modal-content">
        <div class="modal-header">
          <LanguageSwitcher />
          <h3>{{ t('account.title') }}: </h3>
          <button class="close-button" @click="toggleUserModal">
            <font-awesome-icon :icon="['fas', 'times']" />
          </button>
        </div>

        <div class="modal-body">
          <!-- Añadir botón para ver reportes -->
  <button @click="openReports" class="reports-button">
      <i class="fas fa-chart-bar"></i>{{ t('report.tittle') }}
    </button>
    
    <!-- Modal de reportes -->
    <div v-if="showReports" class="modal-overlay">
      <PlayerReports @close="closeReports" />
    </div>
          <div class="info-item">
            <span class="info-label">
              <font-awesome-icon :icon="['fas', 'sack-dollar']" /> {{ t('account.credit') }}: 
            </span>
            <span class="info-value">{{ currency_prefix }} {{ formattedBalance }}</span>
          </div>

          <div class="info-item">
            <span class="info-label">
              <font-awesome-icon :icon="['fas', 'gift']" /> {{ t('account.bonus') }}: 
            </span>
            <span class="info-value">{{ currency_prefix }} {{ playerStore.formattedBonusBalance }}</span>
          </div>

          <div class="info-item">
            <span class="info-label">
              <font-awesome-icon :icon="['fas', 'user']" /> {{ t('app.username') }}: 
            </span>
            <span class="info-value">{{ authStore.user?.username }}</span>
          </div>

          <div class="info-item">
            <span class="info-label">
              <font-awesome-icon :icon="['fas', 'id-card']" /> {{ t('account.id') }}: 
            </span>
            <span class="info-value">{{ authStore.user?.id }}</span>
          </div>

          <button @click="authStore.logout" class="logout-btn">
            <font-awesome-icon :icon="['fas', 'right-from-bracket']" /> {{ t('account.logout') }}: 
          </button>
        </div>
      </div>
    </div>
  </div>
  
</template>

<style scoped>
@import '../../assets/styles/online/OnlineMain.css';
</style>

